
import Vue from 'vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import { ACTIONS } from '@/constants/actions';
import ForgetPasswordForm from '../components/ForgetPasswordForm.vue';
import { mapGetters } from 'vuex';
import { APP_VUEX_MODULES } from '../constants/vuex-modules';
import { GETTERS } from '../constants/getters';

export default Vue.extend({
  components: { AuthLayout, ForgetPasswordForm },
  name: 'ForgetPassword',
  computed: {
    ...mapGetters(APP_VUEX_MODULES.authentication, {
      isSubmitting: GETTERS.authentication.isSubmittingForgetPasswordRequest
    }),
    ...mapGetters(APP_VUEX_MODULES.ui, {
      locale: GETTERS.ui.locale
    })
  },
  methods: {
    submit(data: { email: string }): void {
      const { dispatch } = this.$store;
      dispatch(ACTIONS.authentication.forgetPassword, data);
    },
    navigateTo(path: string): void {
      this.$router.push(path);
    }
  }
});
